import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import Sidebar from './Sidebar';

export interface PropsBadge {
  text?: string;
  color?: string;
  background?: string;
}

export interface ItemProps extends React.PropsWithChildren<RouteComponentProps> {
  path?: string;
  text?: string;
  icon?: string;
  danger?: boolean;
  badge?: PropsBadge;
}

class Item extends React.Component<ItemProps> {

  state = {
    isOpen: false
  }

  private hasChild = false;
  private childrenHeight = 0;
  private submenuRef = React.createRef<HTMLDivElement>();

  render() {
    const props = this.props;
    return props.path == null ? this.renderMultiItem(props) : this.renderSingleItem(props);
  }

  componentDidMount() {
    const element = this.submenuRef.current;
    if (element) {
      this.childrenHeight = element.scrollHeight;
    }
    if (this.childrenPathMatch()) {
      this.setState({ isOpen: true });
    }
  }

  private renderMultiItem = (props: ItemProps) => {
    this.hasChild = props.children != null;
    const isOpen = this.state.isOpen;
    const isUrlMatch = props.path === window.location.pathname;

    let liClassname = 'nav-item';
    if (isOpen || isUrlMatch) liClassname += ' active';
    if (this.hasChild) liClassname += ' has-child';

    let arrowClassname = 'fal fa-angle-down arrow-icon';
    if (isOpen) arrowClassname += ' fa-rotate-180';

    return (
      <li className={liClassname}>
        <div className={'nav-item' + (this.props.danger ? ' nav-danger' : '')} onClick={this.onItemClick}>
          <i className={props.icon ?? ''}></i>
          <span>{props.text}</span>
          {this.hasChild ? <i className={arrowClassname}></i> : ''}
        </div>
        {this.hasChild ?
          (
            <div className="submenu" ref={this.submenuRef} style={{ height: this.calculateHeight() }}>
              <ul>
                {props.children}
              </ul>
            </div>
          ) : ''
        }
      </li>
    );
  }

  private renderSingleItem = (props: ItemProps) => {
    const active = this.isPathMatch() ? 'active' : '';
    return (
      <li className={active}>
        <Link to={props.path} className={'nav-item sub-item' + (this.props.danger ? ' nav-danger' : '')} onClick={this.onItemClick}>
          {props.icon == null ? '' : <i className={props.icon ?? 'fal fa-house'}></i>}
          <span>{props.text ?? ''}</span>
          {this.renderBadge()}
        </Link>
      </li>
    );
  }

  private renderBadge = () => {
    const badge = this.props.badge;
    if (!badge) {
      return '';
    }
    return (
      <span
        className="mr-auto sidebar-badge badge"
        style={{ color: badge.color ?? '#ffffff', background: badge.background ?? '#2980B9' }}
      >{badge.text ?? ''}</span>
    );
  }

  private calculateHeight = () => {
    if (this.hasChild) {
      return this.state.isOpen ? this.childrenHeight + 'px' : '0px';
    }
    return this.childrenHeight + 'px';
  }

  private onItemClick = (event: any) => {
    if (this.hasChild) {
      this.setState({ isOpen: !this.state.isOpen }, () => {
        const submenu = this.submenuRef.current;
        if (this.state.isOpen) {
          submenu.style.height = this.childrenHeight + 'px';
        }
        else {
          submenu.style.height = 0 + 'px';
        }
      });
    }
    else {
      Sidebar.closeSidebar();
    }
    this.forceUpdate();
  }

  private isPathMatch = (path?: string) => {
    if (!path) path = this.props.path;
    return window.location.pathname === path;
  }

  private childrenPathMatch = () => {
    const children = React.Children.toArray(this.props.children);
    for (const child of children) {
      const path = ((child as any).props as ItemProps).path;
      if (this.isPathMatch(path)) {
        return true;
      }
    }
    return false;
  }

}

export default withRouter(Item);
